import React, { useState, useEffect } from 'react'
import label from '../../../../../../assets/i18n/en.json'
import AppointmentService from '../../../../../services/api/appointment.service';
import EquipmentService from '../../../../../services/api/equipment.service';
import PracticeLocationSelector from '../../../../templates/components/PracticeLocationSelector';
import HPTSelect from '../../../../templates/components/HPTSelect';

const EquipmentForm = (props) => {
    // Pull properties form parent
    const { initialData, submitHandler } = props;

    const [isLoader, setIsLoader] = useState(false)
    const [formData, setFormData] = useState(initialData)
    const [practiceLocationRooms, setPracticeLocationRooms] = useState([])
    const [equipmentTypes, setEquipmentTypes] = useState()
    const equipmentTypeLookup = () => {
        EquipmentService.equipmentTypeLookup()
            .then((response) => {
                setEquipmentTypes(response);
            })
            .catch(error => {
                // console.log(error)
                // setCheckException(error);
            })
    }
    const onLocationChanged = (newLocationId) => {
        inputChange({ target: { value: '', name: 'practiceLocationRoomId' } })
        inputChange({ target: { value: newLocationId, name: 'practiceLocationId' } });
    }
    useEffect(() => {
        if (equipmentTypes && !equipmentTypes.find(obj => obj.equipmentTypeId === formData.equipmentTypeId)) {
            formData.equipmentTypeId = null;
        }
    }, [equipmentTypes]);

    useEffect(() => {
        AppointmentService.practiceLocationRoomLookup(formData.practiceLocationId)
            .then(
                (response) => {
                    setPracticeLocationRooms(response);
                    setIsLoader(false);
                })
            .catch(error => {
                setIsLoader(false);
            })
    }, [formData.practiceLocationId])

    useEffect(() => {
        equipmentTypeLookup()
    }, [])

    // formula for input change
    const inputChange = (e) => {
        let newStateObject = { ...formData };
        newStateObject[e.target.name] = e.target.value
        setFormData(newStateObject);
        return console.log(formData)
    };

    return (
        <div>
            {isLoader && <div className="ui">
                <div className="ui active dimmer">
                    <div className="ui indeterminate text loader">{label.common.processing}</div>
                </div>
            </div>}
            <form className=''>
                <div className="ui content">
                    <div className="">

                        <div className="required field">
                            <label> {label.equipment.add.equipmentName}</label>
                            <input placeholder="Equipment" type="text" name="description" value={formData.description} onChange={(e) => { e.preventDefault(); inputChange(e) }} />
                            {/* <span>{formErrors.EquipmentTypeName}</span> */}
                        </div>
                        <div className="required field">
                            <label>{label.equipment.add.equipmentTypeName}</label>
                            <HPTSelect
                                className="react-select-container"
                                classNamePrefix="react-select"
                                options={equipmentTypes}
                                name="equipmentTypeId"
                                value={equipmentTypes && equipmentTypes.find(obj => obj.equipmentTypeId === formData.equipmentTypeId)}
                                onChange={e => {
                                    inputChange({
                                        target:
                                            { value: e.equipmentTypeId, name: 'equipmentTypeId' }
                                    })
                                }}
                                getOptionLabel={(option) => option.equipmentType}
                                getOptionValue={(option) => option.equipmentTypeId}
                            />
                        </div>
                        <div className="required field">
                            <label>Practice Location</label>
                            <PracticeLocationSelector locationId={formData?.practiceLocationId ? formData?.practiceLocationId : null} disabled={props.submitLabel === "Update" ? true : false} onSelected={onLocationChanged} dontResetState={true} />
                        </div>
                        <div>
                            <label>Practice Location Room</label>
                            <HPTSelect
                                className="react-select-container"
                                classNamePrefix="react-select"
                                value={practiceLocationRooms && practiceLocationRooms.find(obj => obj.practiceLocationRoomId === formData.practiceLocationRoomId)}
                                options={practiceLocationRooms}
                                onChange={e => { e ? inputChange({ target: { value: e.practiceLocationRoomId, name: 'practiceLocationRoomId' } }) : inputChange({ target: { value: '', name: 'practiceLocationRoomId' } }) }}
                                isClearable={true}
                                getOptionLabel={(option) => option.room }
                                getOptionValue={(option) => option.practiceLocationRoomId}
                            />
                        </div>
                    </div>
                </div >
            </form >
            <div className="mt-3 d-flex justify-content-between modal-button-bar">
                <div className='col-auto'>
                    <button className="btn btn-primary" onClick={(e) => { e.preventDefault(); submitHandler(formData) }}>{props.submitLabel}</button>
                </div>
                <div className='col-auto'>
                    <button className="btn btn-secondary" onClick={(e) => { e.preventDefault(); props.onClose() }}> Cancel </button>
                </div>
            </div >
        </div >
    )
}

export default EquipmentForm